import { defineNuxtPlugin, useCookie } from '#imports'

import { COOKIES, type CustomizableCookie } from '~/scopes/legal/constants'
import {
  type UserCookies,
  useLegalStore,
} from '~/scopes/legal/stores/useLegalStore'

export default defineNuxtPlugin(() => {
  const legalStore = useLegalStore()

  const cookiesFromBrowser: UserCookies = Object.entries(COOKIES)
    .filter(([, cookieKey]) => {
      const storageCookie = useCookie<boolean>(cookieKey)

      return typeof storageCookie.value === 'boolean'
    })
    .reduce(
      (acc, [cookieType, cookieKey]) =>
        ({
          ...acc,
          [cookieType as CustomizableCookie]:
            useCookie<boolean>(cookieKey).value,
        }) as Record<CustomizableCookie, boolean>,
      {} as UserCookies,
    )

  legalStore.load({ cookiesFromBrowser })
})
